import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const usePerformanceMonitor = () => {
  useEffect(() => {
    if (!('PerformanceObserver' in window)) {
      console.warn(
        'PerformanceObserver not supported, cannot monitor long tasks.',
      );
      datadogRum.addAction('performance_observer_not_supported');
      return;
    }

    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === 'longtask') {
          console.warn('Long task detected:', entry);
          datadogRum.addAction('long_task_detected', {
            duration: entry.duration,
            name: entry.name,
          });
        }
      }
    });

    try {
      observer.observe({ entryTypes: ['longtask'] });
    } catch (e) {
      console.error('Could not observe performance entries:', e);
    }

    return () => {
      observer.disconnect();
    };
  }, []);
};
